
































































import Vue from "vue";
import Map from "@/components/Map/Map.vue";
import NavbarTitle from "@/components/Text/Navbar/NavbarTitle.vue";

export default Vue.extend({
  name: "MapBar",
  components: { NavbarTitle, Map },
  props: {
    map_should_be_displayed: {
      type: Boolean
    },
    mapDatas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      map_classes: "map-display"
    };
  },
  methods: {
    mapDisplayToggle(): void {
      this.$emit("toggle-map");
    }
  },
  watch: {
    map_should_be_displayed(): void {
      if (this.map_should_be_displayed) this.map_classes = "map-display map-display-up";
      else this.map_classes = "map-display map-display-down";
    }
  }
});
